import { useGetProducts } from ':cloud/queries/BillingQueries/useGetProducts';
import { MeterTier } from ':cloud/types/ts_types';

function useBillingTiers(): MeterTier[] {
  const { products } = useGetProducts();

  const waasVariant = products[0]?.variants.find((variant) => variant.active);

  if (!waasVariant?.meters[0]) {
    return [];
  }

  const { tiers, pricePerUnit } = waasVariant.meters[0];

  const modifiedTiers: MeterTier[] = [
    {
      pricePerUnit,
      startingUnit: '0',
    },
    ...tiers,
  ];

  return modifiedTiers;
}

export default useBillingTiers;
